import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./Slices/authSlice";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import villageSlice from "./Slices/villageSlice";
import talukaSlice from "./Slices/talukaSlice";
import districtSlice from "./Slices/districtSlice";
import occupationSlice from "./Slices/occupationSlice";
import educationSlice from "./Slices/educationSlice";
import entertainmentSlice from "./Slices/entertainmentSlice";
import committeeSlice from "./Slices/committeeSlice";
import relationSlice from "./Slices/relationSlice";
import userAnalyticsSlice from "./Slices/userAnalyticsSlice";
import messageSlice from "./Slices/messageSlice";
import userTypeSlice from "./Slices/userTypeSlice";
import fundsSlice from "./Slices/fundsSlice";
import yearSlice from "./Slices/yesrSlice";
import donatorsSlice from "./Slices/donatorSlice";
import awardSlice from "./Slices/awardSlice";
import honoredSlice from "./Slices/honoredSlice";
import resultSlice from "./Slices/resultSlice";
import gallerySlice from "./Slices/gallerySlice";
import settingsSlice from "./Slices/settingsSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  village: villageSlice,
  taluka: talukaSlice,
  district: districtSlice,
  occupation: occupationSlice,
  education: educationSlice,
  entertainment: entertainmentSlice,
  committee: committeeSlice,
  relation: relationSlice,
  userAnalytic:userAnalyticsSlice,
  message: messageSlice,
  gallery: gallerySlice,
  userType:userTypeSlice,
  funds: fundsSlice,
  year: yearSlice,
  donators:donatorsSlice,
  award:awardSlice,
  honored:honoredSlice,
  result:resultSlice,
  settings: settingsSlice
});

const persistConfig = {
    key: "root",
    storage,
    blacklist: ["sideBar", "common"],
  };
  
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  
  /* ============================== STORE ============================== */
  
  export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
  
  /* ============================== PERSIST-STORE ============================== */
  
  export const persistor = persistStore(store);